import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const Title = styled(Typography, {
  name: 'Title',
  slot: 'Root',
  skipSx: true,
})(
  ({ theme }) => `
  font-family: 'Source Sans Pro Semibold';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  margin-bottom: 12px;
  color: ${theme.palette.text.primary};
`,
)
